/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import { event } from 'y4/Utils';

const SearchBox = ({ className, size = '' }) => {
  const [state, setState] = useState(null);
  const [value, setValue] = useState(state?.value);

  const buttonClick = () => {
    state.search(value);
  };
  const inputKeyDown = e => {
    if (e.keyCode == 13) {
      state.search(value);
    }
  };

  useEffect(() => {
    event.on('setNavbarTopSearchBox', e => {
      setState(e.detail.data);
      setValue(e.detail.data?.value);
    });
  }, []);

  return state ? (
    <InputGroup
      size={size}
      className={classNames(className, 'position-relative')}
    >
      <FormControl
        value={value || ''}
        onChange={({ target: { value } }) => {
          setValue(value);
        }}
        onKeyDown={inputKeyDown}
        id="search"
        placeholder={state.placeholder}
        type="search"
        className="shadow-none"
      />
      <Button
        variant="outline-secondary"
        className="border-300 hover-border-secondary"
        onClick={buttonClick}
      >
        <FontAwesomeIcon icon="search" className="fs--1" />
      </Button>
    </InputGroup>
  ) : null;
};

export default SearchBox;
